import { css } from '@emotion/react';
import * as React from 'react';

import { QuestionVerificationStatus } from '../../interfaces/IWorkflow';
import colors from '../../theme/colors';
import { APP_TOOLTIP_ID } from '../common/Tooltip/constants';
import { CheckCircleIcon, WarningIcon } from './icons';

const VERIFIED = 'Verified';
const NEEDS_VERIFICATION = 'Need verification';

interface QuestionVerificationStatusIconProps extends React.SVGProps<SVGSVGElement> {
  verificationStatus: QuestionVerificationStatus;
  disabled?: boolean;
}

const QuestionVerificationStatusIcon = ({
  verificationStatus,
  disabled = false,
  ...other
}: QuestionVerificationStatusIconProps) => {
  switch (verificationStatus) {
    case QuestionVerificationStatus.Verified: {
      const props = { color: disabled ? colors.neutral300 : colors.statusGreen, ...other };

      return (
        <CheckCircleIcon
          css={css`
            width: 18px;
            min-width: 18px;
            height: 18px;
          `}
          data-tooltip-id={APP_TOOLTIP_ID}
          data-tooltip-content={VERIFIED}
          role="img"
          aria-label={VERIFIED}
          {...props}
        />
      );
    }
    case QuestionVerificationStatus.NeedsVerification: {
      const props = { color: disabled ? colors.neutral300 : colors.orange400, ...other };

      return (
        <WarningIcon
          css={css`
            width: 18px;
            min-width: 18px;
            height: 18px;
          `}
          data-tooltip-id={APP_TOOLTIP_ID}
          data-tooltip-content={NEEDS_VERIFICATION}
          role="img"
          aria-label={NEEDS_VERIFICATION}
          {...props}
        />
      );
    }
    default:
      return null;
  }
};

export default QuestionVerificationStatusIcon;
